import React, { Fragment, useContext } from 'react';
import UltimoCambio from './UltimoCambio';
import proyectoContext from '../../context/proyectos/proyectoContext';
import { CSSTransition, TransitionGroup } from 'react-transition-group';

const DetallesProyectos = () => {

    // Extraer proyectos de state inicial
    const proyectosContext = useContext(proyectoContext);
    const { proyecto, ultimoscambiosproyecto } = proyectosContext;
    
    // Si se elimina un proyecto y está en detalles
    if(!proyecto) return null;
    
    // Array destructuring para extraer el proyecto actual
    const [ proyectoactual ] = proyecto;

    return ( 
        <Fragment>
            <h2>Proyecto: {proyectoactual.nombre}</h2>

            <ul className="vista-detalles">
                <div className="info-principal">
                    <li className="info-pequeña">
                        <p><span>Nombre:</span> {proyectoactual.nombre}</p>
                    </li>
                    <li className="info-pequeña">
                        <p><span>Fecha de creación:</span> {proyectoactual.fechaCreacion}</p>
                    </li>
                </div>
                
                <div>
                    <li className="info-normal">
                        <p><span>Creado por:</span> {proyectoactual.creador}</p>
                    </li>
                </div>

                <div>
                    <h3>Ultimos Cambios:</h3>

                    {ultimoscambiosproyecto.length === 0
                        ?
                            <li className="ultimo-cambio"><p className="sin-cambios">No hay cambios</p></li>
                        :
                        <TransitionGroup>
                            {ultimoscambiosproyecto.map(ultimocambio => (
                                <CSSTransition
                                    key={ultimocambio._id}
                                    timeout={200}
                                    classNames="tarea"
                                >
                                    <UltimoCambio 
                                        ultimocambio={ultimocambio}
                                    />
                                </CSSTransition>
                            ))}
                        </TransitionGroup>
                    }
                </div>
            </ul>
        </Fragment>
    );
}
 
export default DetallesProyectos;